import styled from 'styled-components'
import { GatsbyImage } from 'gatsby-plugin-image'
import theme from 'styles/theme'
import { isTablet } from 'react-device-detect'
import { getBGColor } from 'utils/themeUtils'

export const CardModalButton = styled.div`
  display: block;
  background-color: ${getBGColor()};
  padding: 2px 4px;
  border-radius: 100px;
  position: absolute;
  right: ${theme.space[3]};
  top: ${theme.space[2]};
  z-index: 1;

  ${theme.mediaQueries.medium} {
    display: ${isTablet ? 'block' : 'none'};
    right: ${theme.space[6]};
  }

  ${theme.mediaQueries.ipad_landscape} {
    display: block;
  }
`

export const ProductCardWrapper = styled.article`
  position: relative;
  width: 100%;
  height: ${(props) => (props.isCallout ? '90%' : 'unset')};

  ${theme.mediaQueries.medium} {
    &:hover {
      cursor: pointer;
    }
    &:hover ${CardModalButton} {
      display: block;
      position: absolute;
      right: ${theme.space[2]};
      top: ${theme.space[2]};
      z-index: 1;
    }
  }
  ${theme.mediaQueries.mobile} {
    max-width: ${(props) => (props.isCallout ? '100%' : '45vw')};
    margin: 0.12em;
  }

  ${theme.mediaQueries.ipad_portrait} {
    max-width: 49vw;
    margin: 0.12em;
  }
`

export const ProductCardImage = styled(GatsbyImage)`
  width: 100%;
  aspect-ratio: 10 / 16;
  @supports not (aspect-ratio: 10 / 16) {
    ${(props) => `height: ${props.width * 1.6}px;`}
  }
`

export const ProductCardInfoWrapper = styled.div`
  padding: ${theme.space[5]} 0;

  ${theme.mediaQueries.medium} {
    padding: ${theme.space[5]} 0;
  }
`

export const ProductCardVideoWrapper = styled.div`
  width: 100%;
  aspect-ratio: 10 / 16;
  @supports not (aspect-ratio: 10 / 16) {
    ${(props) => `height: ${props.width * 1.6}px;`}
  }
  overflow: hidden;
`
